export const SHOW_PROGRESS_SPINNER = 'SHOW_PROGRESS_SPINNER';
export const HIDE_PROGRESS_SPINNER = 'HIDE_PROGRESS_SPINNER';
export const STORE_PAGE_INFO = 'STORE_PAGE_INFO';
export const STORE_CARD_INFO = 'STORE_CARD_INFO';
